export function processCorrelations(ctx, { fetch, variables }) {
  return fetch(variables)
    .then(data => {
      ctx.correlColumns = data.map(d => d.row).slice(0, -2);
      let pAux = data[data.length - 2];
      let pAux1 = data[data.length - 1];
      let _this = ctx;
      ctx.prices = [];

      ctx.correlColumns.forEach(function(d) {
        _this.prices.push(+pAux[d]);
        _this.change.push(+pAux1[d]);
      });
      ctx.correlation = [];
      ctx.diagonal = [];
      let i, j, idx, idx2;
      for (i = 0; i < data.length - 2; i++) {
        idx = data[i].row;
        for (j = 0; j < ctx.correlColumns.length; j++) {
          idx2 = ctx.correlColumns[j];
          ctx.correlation.push({
            x: idx,
            y: ctx.correlColumns[j],
            correl: +data[i][idx2]
          });
          if (i === j) {
            ctx.diagonal.push({
              x: 1,
              y: ctx.correlColumns[j],
              correl: +data[0][idx2]
            });
          }
        }
      }
      ctx.showLoading = false;
    })
    .catch(function(error) {
      ctx.showLoading = false;
      console.log(error);
    });
}
